import * as actionTypes from '../types/infoHistory';

export function getInfoHistory(payload) {
  return {
    type: actionTypes.GET_INFO_HISTORY,
    payload
  };
}

export function getInfoHistorySuccess(payload) {
  return {
    type: actionTypes.GET_INFO_HISTORY_SUCCESS,
    payload
  };
}

export function getInfoHistoryFail(payload) {
  return {
    type: actionTypes.GET_INFO_HISTORY_FAIL,
    payload
  };
}
